import { useContext } from 'react';
import { CnFormArrayBaseContext } from '../context';
export var useArray = function () {
    return useContext(CnFormArrayBaseContext);
};
